import { findVariable, getElementAttribute, getProxyHandler, runExecuteCode, runIfCode, debug } from "./common";
import { Element } from "./Element";
import { ObjectProxyHandler } from "./ObjectProxyHandler";
import { FormatFactory } from "./format/FormatFactory";
import { PropertyChangedEvent } from "./event/PropertyChangedEvent";
/**
 * Object Element
 */
export class ObjectElement extends Element {
    /**
     * Constructor
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    constructor(htmlElement, bindData, context) {
        super(htmlElement, bindData, context);
        // attributes
        this.property = getElementAttribute(htmlElement, 'property');
        let format = getElementAttribute(htmlElement, 'format');
        if (format) {
            this.format = FormatFactory.getFormat(format);
        }
    }
    /**
     * Checks available state
     */
    isAvailable() {
        return document.contains(this.htmlElement);
    }
    /**
     * Gets property
     */
    getProperty() {
        return this.property;
    }
    /**
     * Gets format
     */
    getFormat() {
        return this.format;
    }
    /**
     * Overrides render
     */
    render() {
        // context
        let context = Object.assign({}, this.getContext());
        let bind = getElementAttribute(this.getHtmlElement(), 'bind');
        let bindSplit = bind.split('.');
        if (bindSplit.length > 1) {
            context[bindSplit[0]] = findVariable(context, bindSplit[0]);
        }
        else {
            context[bind] = this.getBindData();
        }
        // run if code
        runIfCode(this.htmlElement, context).then(result => {
            // checks result
            if (result === false) {
                return;
            }
            let objectProxyHandler = getProxyHandler(this.getBindData());
            // set value
            if (this.property) {
                let value = objectProxyHandler.getValue(this.property);
                this.setValue(value);
            }
            // sets readonly
            let readonly = objectProxyHandler.isReadonly(this.property);
            this.setReadonly(readonly);
            // sets disabled
            let disabled = objectProxyHandler.isDisabled(this.property);
            this.setDisabled(disabled);
            // run execute code
            runExecuteCode(this.htmlElement, context).then();
        });
    }
    /**
     * Updates
     * @param observable observable
     * @param event event
     */
    update(observable, event) {
        debug('ObjectElement.update', observable, event);
        // ObjectHandler
        if (observable instanceof ObjectProxyHandler) {
            // property changed event
            if (event instanceof PropertyChangedEvent) {
                this.render();
                return;
            }
        }
        // default
        this.render();
    }
    /**
     * Sets property value
     * @param value property value
     */
    setValue(value) {
        if (value != null) {
            value = this.getFormat() ? this.getFormat().format(value) : value;
            this.htmlElement.innerText = value;
        }
        else {
            this.htmlElement.innerText = '';
        }
    }
    /**
     * Gets property value
     */
    getValue() {
        let value = this.htmlElement.innerText;
        if (value && value.trim().length > 0) {
            value = this.getFormat() ? this.getFormat().parse(value) : value;
        }
        else {
            value = null;
        }
        return value;
    }
    /**
     * Sets readonly
     * @param readonly readonly or not
     */
    setReadonly(readonly) {
        // no-op
    }
    /**
     * Sets disabled
     * @param disabled disabled or not
     */
    setDisabled(disabled) {
        // no-op
    }
    /**
     * Gets index
     */
    getIndex() {
        let index = getElementAttribute(this.htmlElement, 'index');
        if (index) {
            return Number(index);
        }
    }
    /**
     * Focus
     */
    focus() {
        // no-ops
        return false;
    }
}
//# sourceMappingURL=ObjectElement.js.map